/**
 * Connected device
 */
import {ConnectionState, ReadOptions} from "./types";
import {PsdkConst} from "../../father";

export interface ConnectedDevice {

  origin(): any;

  /**
   * Connected device name
   */
  deviceName(): string;

  /**
   * Connection state
   */
  connectionState(): ConnectionState;

  /**
   * disconnect device
   */
  disconnect(): Promise<void>;

  /**
   * can read
   */
  canRead(): boolean;

  /**
   * Write data
   */
  write(data: Uint8Array): Promise<void>;

  /**
   * Read data
   */
  read(options?: ReadOptions): Promise<Uint8Array>;

  /**
   * notify data
   */
  notify(callback: (value: Uint8Array) => Promise<void>): void;

  /**
   * flush read data
   */
  flush(): void;
}

/**
 * Fake connected device
 */
export class FakeConnectedDevice implements ConnectedDevice {
  origin(): any {
    return "FAKE-DEVICE";
  }

  connectionState(): ConnectionState {
    return ConnectionState.CONNECTED;
  }

  deviceName(): string {
    return "FAKE-DEVICE";
  }

  async disconnect(): Promise<void> {
  }

  canRead(): boolean {
    return true;
  }

  async read(options?: ReadOptions): Promise<Uint8Array> {
    return PsdkConst.EMPTY_BYTES;
  }

  async write(data: Uint8Array) {
    console.log('WRITE: ', data);
  }

  flush(): void {
  }

  notify(callback: (value: Uint8Array) => Promise<void>): void {
  }

}
